module.exports = __webpack_public_path__ + "media/ecom/processing-dab34778.svg";